/**
 * Adds a `fonts-ready` class to <html> once webfonts are loaded, so icon
 * ligatures (Material Symbols) can be hidden until the font is available.
 * Falls back to a timeout so icons are never hidden permanently if the
 * Font Loading API hangs or is unavailable.
 */
export function ensureFontsReady(doc: Document = document, timeoutMs = 3000): void {
  let done = false;
  const finish = () => {
    if (done) return;
    done = true;
    doc.documentElement.classList.add('fonts-ready');
  };

  const fonts = (doc as Document & { fonts?: { ready?: Promise<unknown> } }).fonts;
  if (fonts && typeof fonts.ready?.then === 'function') {
    fonts.ready.then(finish, finish);
    setTimeout(finish, timeoutMs);
  } else {
    finish();
  }
}
